export default __webpack_public_path__ + "static/media/sign-text-icon.1d307b11.svg";